<template>
  <grocery-estimation-and-cost />
</template>

<script setup lang="ts">
import GroceryEstimationAndCost from '@/components/Main/Operator/Grocery/GroceryEstimationAndCost.vue';
</script>
